import {ComponentDefinition} from '@contentful/experiences-sdk-react';

export const AdoptionMapContentfulComponentDefinition: ComponentDefinition = {
  id: 'adoptionMap',
  name: 'Adoption Map',
  category: '08: Advanced',
  thumbnailUrl:
    'https://contentful-images.code.org/90t6bu6vlf76/4yTiY2oxdtFoGa03UEyFM6/33f122b1e4e4f5ad1f028d84fd93b5be/component_adoption_map_thumbnail.png',
  tooltip: {
    description: 'This component embeds the interactive adoption map only.',
    imageUrl:
      'https://contentful-images.code.org/90t6bu6vlf76/2yJjmhq8uWIc03k81YXVRT/d97f72b237f4ffbcdb786d9cc3da5153/component_adoption_map_tooltip.png',
  },
  variables: {},
};
